<template>
  <div class="signup">

    <p class="msg" style="text-align: center;">
      {{ title }}
    </p>

    <van-notice-bar class="msg" wrapable :scrollable="false">
      <span>
        <van-icon class="msg-icon" name="volume-o" />
        <span style="white-space: pre-wrap;" v-html="tips
        ? tips
        : `尊敬的老师，您好！感谢您对大会的全力支持！`"></span>

      </span>
    </van-notice-bar>
    <van-form ref="form" @submit="onSubmit">
      <template v-for="item in tableList">
        <template v-if="item.delFlag === 0">
          <van-field :readonly="readonly" v-if="item.fieldName === 'name'" :key="item.fieldName"
            v-model="form[item.fieldName]" :name="item.fieldName" :label="item.fieldTitle"
            :placeholder="`请输入${item.fieldTitle}`" :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

          <div v-if="item.fieldName === 'mobile'" :key="item.fieldName">
            <van-field :readonly="readonly" v-model="form[item.fieldName]" type="tel" :name="item.fieldName"
              placeholder="请输入手机号" :label="item.fieldTitle" :rules="[
                {
                  pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
                  message: '请填写正确的手机号'
                }
              ]" />
          </div>
          <div v-if="item.fieldName === 'professional'" :key="item.fieldName">
            <van-field :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
              :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" readonly clickable
              v-model="form[item.fieldName]" @click="showPicker = true" />
            <van-popup v-model="showPicker" position="bottom" v-if="!readonly">
              <van-picker show-toolbar :columns="jisdjs" @confirm="onJisdjConfirm" @cancel="showPicker = false" />
            </van-popup>
          </div>

          <van-field :readonly="readonly" v-if="item.fieldName === 'company'" :key="item.fieldName"
            v-model="form[item.fieldName]" :name="item.fieldName" :label="item.fieldTitle"
            :placeholder="`请输入${item.fieldTitle}`" :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

          <div v-if="item.fieldName === 'companytype'" :key="item.fieldName">
            <van-field :readonly="readonly" :name="item.fieldName" :label="item.fieldTitle"
              :placeholder="`请输入${item.fieldTitle}`" :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]"
              clickable v-model="form[item.fieldName]" @click="showType = true" />
            <van-popup v-model="showType" position="bottom">
              <van-picker show-toolbar :columns="types" @confirm="onTypesConfirm" @cancel="showType = false" />
            </van-popup>
          </div>

          <van-field :readonly="readonly" v-if="item.fieldName === 'idCard'" :key="item.fieldName"
            v-model="form[item.fieldName]" :name="item.fieldName" :label="item.fieldTitle"
            :placeholder="`请输入${item.fieldTitle}`" :rules="[
              {
                pattern: /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/,
                message: '请填写正确的身份证号码'
              }
            ]" />

          <van-field :readonly="readonly" v-if="item.fieldName === 'bankCard'" :key="item.fieldName"
            v-model="form[item.fieldName]" :name="item.fieldName" :label="item.fieldTitle"
            :placeholder="`请输入${item.fieldTitle}`" :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

          <van-field :readonly="readonly" v-if="item.fieldName === 'bankDeposit'" :key="item.fieldName"
            v-model="form[item.fieldName]" :name="item.fieldName" :label="item.fieldTitle"
            :placeholder="`请输入${item.fieldTitle}`" :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

          <!-- 备用表单部分，备用字段统一spare开头，通过这个特征判断 -->
          <!-- 由于备用表单元素不确定性，所以需要依靠返回数据来渲染 -->
          <template v-if="item.fieldName.search('spare') === 0">
            <!-- input -->
            <van-field :readonly="readonly" v-if="item.htmlType === 'text'" :key="item.fieldName"
              v-model="form[item.fieldName]" :name="item.fieldName" :label="item.fieldTitle"
              :placeholder="`请输入${item.fieldTitle}`" :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

            <!-- 单选 -->
            <van-field :readonly="readonly" v-if="item.htmlType === 'select'" :key="item.fieldName"
              :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
              :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]">
              <template #input>
                <van-radio-group :disabled="readonly" v-model="form[item.fieldName]" direction="horizontal">
                  <van-radio v-for="code in item.codeConent.split(',')" :key="code.split(':')[0]"
                    :name="code.split(':')[0]">{{ code.split(':')[1] }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </template>
        </template>
      </template>

      <div style="margin: 16px;" v-if="tableList && tableList.length > 0">
        <van-button block type="info" native-type="submit" :disabled="readonly">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import apis from "@/config/apis";
import yqyapis from "@/config/yqyapis";
import { areaList } from "@vant/area-data";
import { getCorpCode } from "@/config/yqy";
import { Dialog } from "vant";
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";

export default {
  mixins: [share],
  name: "Signup",
  data: () => ({
    tableList: [],
    tips: "",
    liveName: "",
    projectName: "",
    form: {
      uname: ""
    },
    corpCode: {},
    jisdjs: [
      "主任医师",
      "主任药师",
      "主任护师",
      "主任技师",
      "副主任医师",
      "副主任药师",
      "副主任护师",
      "副主任技师",
      "主治（主管）医师",
      "主管药师",
      "主管护师",
      "主管技师",
      "医师、医士",
      "药师、药士",
      "护师、护士",
      "技师、技士",
      "其他"
    ],
    areaList,
    types: ["医院", "药房", "科研机构", "其他"],
    showPicker: false,
    showArea: false,
    showType: false,
    needCaptcha: true,
    title: "",
    readonly: false,
  }),
  created() {
    this.corpCode = getCorpCode();
    this.collectFeeFormData();
    this.getUserInfo();
    //this.getNeedcaptcha();
    document.title = "专家课酬劳务费信息采集表";


  },
  methods: {
    async collectFeeFormData() {
      try {
        let { projectCode, liveCode } = this.$route.query;
        if (projectCode === 'undefined') {
          projectCode = "";
        }
        if (liveCode === 'undefined') {
          liveCode = "";
        }
        const resp = await yqyapis.collectFee.formData(projectCode || '', liveCode || '');
        if (resp.success === true) {
          if (resp.data.collectFee) {
            this.readonly = true;
          }
          this.tableList = resp.data.formDataList;
          this.tips = resp.data.tips;
         
          this.liveName = resp.data.liveName;
          this.projectName = resp.data.projectName;
          this.title = resp.data.share.shareTitle;

          if(this.title)
          {
            document.title = this.title;
          }

          if (getEnv() !== "h5") {
            let url = window.location.href.split("?")[0];
            if (this.corpCode) {
              url = url + "?corpCode=" + this.corpCode
            }
            if (projectCode) {
              url = url + "&projectCode=" + projectCode
            }
            if (liveCode) {
              url = url + "&liveCode=" + liveCode
            }
            this.onDWShare({
              link: url, desc: resp.data.share.shareContent, imgUrl: resp.data.share.shareImgUrl, title: resp.data.share.shareTitle
            });
          }


          if (resp.data.collectFee) {
            this.form = resp.data.collectFee;
            Dialog.alert({
              title: "温馨提示",
              message: "本次会议课程信息您已提交"
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    onSubmit(values) {
      try {


        Dialog.confirm({
          title: '提示',
          message:
            '提交后不可以修改，请检查点击确认提交！',
        })
          .then(async () => {
            let { projectCode, liveCode } = this.$route.query;
            if (projectCode === 'undefined') {
              projectCode = "";
            }
            if (liveCode === 'undefined') {
              liveCode = "";
            }
            values.projectCode = projectCode || '';
            values.liveCode = liveCode || '';
            const resp = await yqyapis.collectFee.add(values);
            const { success, msg } = resp;
            if (success === true) {
              this.readonly = true;
              this.$toast.fail("提交成功！");
            } else {
              this.$toast.fail(msg);
            }
          })
          .catch(() => {
            // on cancel
          });


      } catch (error) {
        console.log(error);
      }
    },
    onClickCaptch(name) {
      this.$refs.form
        .validate([name])
        .then(() => {
          this.onClickGetCaptcha(this.form[name], 2);
        })
        .catch(err => {
          console.log(err);
        });
    },
    onJisdjConfirm(value) {
      this.form.professional = value;
      this.showPicker = false;
    },
    onAreaConfirm(values) {
      this.form.shenshi = values
        .filter(item => !!item)
        .map(item => item.name)
        .join("/");
      this.showArea = false;
    },
    onTypesConfirm(value) {
      this.form.companytype = value;
      this.showPicker = false;
    },
    // 获取用户信息
    async getUserInfo() {
      try {
        const resp = await apis.user.getUserInfo();
        const { user, success } = resp;
        if (success === "ok") {
          user.xieb = String(user.xieb);
          this.form = Object.assign({}, this.form, user);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取是否需要验证码
    async getNeedcaptcha() {
      const { zbcode } = this.$route.query;
      try {
        const resp = await apis.detail.fetchNeedcaptcha(zbcode);
        const { success, needcaptcha } = resp;
        if (success === "ok") {
          this.needCaptcha = needcaptcha;
        }
      } catch (error) {
        console.log(error);
      }
    },

    onClickRight() {
      this.$router.push(
        {
          path: "/dw/",
          query: { corpCode: this.corpCode }
        });

    },
  }
};
</script>

<style lang="scss">
.signup {
  padding-top: 0px;

  .msg {
    font-size: 13px;
    padding: 15px;
    line-height: 1.4;
    white-space: pre-wrap;

    .msg-icon {
      margin-right: 4px;
      vertical-align: text-top;
    }
  }
}

.van-ellipsis {
  white-space: pre-wrap;
}
</style>

